(function ($, Global) {
    // Help sur OneSignal https://stackoverflow.com/questions/38451760/uncaught-typeerror-onesignal-once-is-not-a-function
    var WebPush = function () {
        this.cookieManager = new Global.CookieManager();
        this.isSubscribed = false
        this.isGlitz = Global.location.hostname.includes('glitz.paris');
    };
    var urlParams = new UrlParams();
    var alreadyInit = false;
    var alreadySubscribe = false;

    Global.OneSignal = Global.OneSignal || [];

    WebPush.prototype.initEvents = function () {
        this.publishers();       
        this.subscribers();
    };

    WebPush.prototype.publishers = function () {
        var self = this;

        if (!Global.PUSH_APP_ID || !self.isSupported()) return;

        var timer = setInterval(function () {
            if (Global.OneSignal) {
                self.initOneSignal();
                clearInterval(timer);
            }
        }, 300);
    };

    WebPush.prototype.subscribers = function () {
        var self = this;

        $.Topic('notif-subscribe').subscribe(function () {
            self.subscribe();
        });

        $.Topic('notif-state-enabled').subscribe(function (callback) {
            self.isPushEnabled(callback);
        });

        $.Topic('notif-permission').subscribe(function (callback) {
            self.getPermission(callback);
        });

        $.Topic('get-notif-tags').subscribe(function (callback) {
            self.getTags(callback);
        });

        $.Topic('send-notif-tags').subscribe(function () {
            self.sendTags();
        });
    };

    WebPush.prototype.isSupported = function () {
        return ('Notification' in window) && ('serviceWorker' in navigator);
    };

    WebPush.prototype.initOneSignal = function () {
        var self = this;
        if (alreadyInit) return;
        var paramNotif = urlParams.getParam('notif');
        alreadyInit = true
        Global.OneSignal.push(function () {
            Global.OneSignal.init({
                appId: Global.PUSH_APP_ID,
                autoResubscribe: true,
                notifyButton: {
                    enable: false,
                    displayPredicate: Global.OneSignal.getNotificationPermission().then(function (permission) {
                        return permission == 'denied' && (paramNotif !== null)
                    }),
                    position: 'bottom-left',
                    showCredit: false,
                    text: Global.notifyButton.text
                },
                welcomeNotification: Global.welcomeNotification
            });

            self.getPermission(function (permission) {
                self.handlePermission(permission)
            })

            Global.OneSignal.on('subscriptionChange', function (isSubscribed) {
                console.log("The user's subscription state is now:", isSubscribed);

                $.Topic('message-notif-hide').publish();
                if (isSubscribed) {
                    self.isSubscribed = isSubscribed
                    $.Topic('message-notif-cookie-create').publish();
                    self.sendTags();
                } else {
                    var services = self.cookieManager.servicesActivate();
                    self.cookieManager.approve(services.filter(function (service) {
                        return service !== 'oneSignal'
                    }));
                }
            });
        });
    }

    WebPush.prototype.isPushEnabled = function (callback) {
        var self = this
        Global.OneSignal.push(function () {
            Global.OneSignal.isPushNotificationsEnabled(callback).catch(self.catchError);
        });    
    };

    WebPush.prototype.subscribe = function () {
        var self = this;
        if (alreadySubscribe) return;
        alreadySubscribe = true;
        if (this.isGlitz && this.isSubscribed) {
            $.Topic('message-notif-hide').publish();
            $.Topic('message-notif-cookie-create').publish();
            this.sendTags();
        } else {
            Global.OneSignal.showNativePrompt().catch(self.catchError);
        }
    };

    WebPush.prototype.getPermission = function (callback) {
        Global.OneSignal.getNotificationPermission().then(callback).catch(this.catchError);
    };

    WebPush.prototype.handlePermission = function (permission) {
        var self = this;
        var paramNotif = urlParams.getParam('notif');
        if (permission == 'granted') {
            self.isSubscribed = true;
            if (self.isGlitz) {
                self.getTags(function (tags) {
                    if (!tags || tags == null || tags == {} || (typeof tags == "string" && tags.replace(/\s/g, "") == "{}") || (typeof tags == "object" && Object.keys(tags).length == 0)) self.sendTags()
                })
            }
        }
        if (permission == 'default' && paramNotif !== null) {
            self.subscribe()
        }
    }

    WebPush.prototype.getTags = function (callback) {
        var self = this;
        Global.OneSignal.push(function () {
            Global.OneSignal.getTags(callback).catch(self.catchError);
        });
    }

    WebPush.prototype.sendTags = function () {
        var self = this
        Global.OneSignal.push(function () {
            Global.OneSignal.sendTags(Global.NOTIF_TAGS).catch(self.catchError);
        });
    }

    WebPush.prototype.catchError = function (error) {
        console.error(error);
        Global.Sentry.captureException(error);
    }

    Global.WebPush = WebPush;
}(jQuery, window));